import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/opt/livekit-frontend/node_modules/.pnpm/react-hot-toast@2.5.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/livekit-frontend/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/opt/livekit-frontend/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/index.css");
;
import(/* webpackMode: "eager" */ "/opt/livekit-frontend/node_modules/.pnpm/@livekit+components-styles@1.2.0/node_modules/@livekit/components-styles/dist/general/prefabs/index.css");
